import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const success = (msg: string, autoClose = 3000, position = 'top-right') =>
  toast.success(msg, {
    //position,
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    draggable: false,
    progress: undefined,
  });
export const failed = (msg: string, autoClose = 3000, position = 'top-right') =>
  toast.error(msg, {
    //position,
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    draggable: false,
    progress: undefined,
  });
/**
 * Longer default than success/failed: warnings here carry consequences the
 * admin has to actually read (e.g. "existing subscribers keep the old price"),
 * and three seconds is not enough to finish a sentence like that.
 */
export const warning = (msg: string, autoClose = 10000, position = 'top-right') =>
  toast.warning(msg, {
    //position,
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    draggable: false,
    progress: undefined,
  });
export const info = (msg: string, autoClose = 3000, position = 'top-right') =>
  toast.info(msg, {
    //position,
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    draggable: false,
    progress: undefined,
  });
